import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/reports/winnings', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/reports/winnings', data, { responseType: 'arraybuffer' })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { store, get }
